<template>
  <div class="carousel-bullets">
    <ul>
      <li v-for="(item, index) in contents" :key="index">
        <a
          href="#"
          :class="{ 'is-active': index === currentSlide }"
          @click.prevent="$emit('nav-to', index)"
        >
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    contents: Array,
    currentSlide: Number
  }
}
</script>

<style lang="scss">
.carousel-bullets {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateZ(400px);

  display: flex;
  justify-content: center;

  a {
    &.is-active {
      color: pink;
    }
  }
}
</style>
